import React from 'react';
import {FormFooter, FormWrapper} from '../../../../FormHandlers';
import {AdminInput, AdminSelect} from '../../../../FormInputs';
import {AdminFormRow, AdminFormCol} from '../../../../AdminHelpers/AdminLayout';
const {DisplayIdAdmin} = require('../../../../DisplayData');

import Button from "../../../../Button/C";
import {default as DeleteIcon} from "@material-ui/icons/Delete";
import {object, string, array} from "yup";
import {apiAdminPaymentsList, apiAdminPaymentsNuveiStatusUpdate} from "../../../../../../api/admin/transactions";
import Field from "../../../../Field/E";

module.exports = ({selected = [], update, close}) => {
  const STATUSES = [
    {id: 'approved', name: 'Approved'},
    {id: 'declined', name: 'Declined'},
    {id: 'ignored', name: 'Ignored'},
  ];

  return (
    <FormWrapper
      className="mt20"
      data={{
        trxList: selected.length
          ? selected.map(({id, review_kind, old_status}) => ({id, review_kind, old_status}))
          : [{}]
      }}
      schema={object().shape({
          trxList: array().of(object().shape({
            review_kind: string().required(),
          }))
        })}
      onSubmit={(data) => {
        const {
          trxList = [],
          chargeback_fee = 0,
          chargeback_fee_eur = 0
        } = data;

        const result = trxList.reduce((acc, next) => {
          const params = {review_kind: next.review_kind}

          if (next.review_kind === 'declined') {
            params['chargeback_fee'] = chargeback_fee;
            params['chargeback_fee_eur'] = chargeback_fee_eur;
          }

          acc[next.id] = params;
          return acc;
        }, {});

        return apiAdminPaymentsNuveiStatusUpdate(result);
      }}
      onResult={() => {
        update();
        close();
      }}
    >{(formCtx) => {

      const trxList = formCtx.state.data.trxList || [];
      const trxErrors = formCtx.state.errors || {};
      const click = formCtx.state.click;

      const onChangeCtor = (i) => (nextValue) => {
        const nextTrxList = [...trxList];
        nextTrxList[i] = {...nextValue};
        formCtx.onManualChange({trxList: nextTrxList})
      };
      const errorGetterCtor = (i) => (name) => trxErrors[`trxList[${i}].${name}`];

      const moteThanOneTrx = trxList.length > 1;
      const hasDeclinedTrx = trxList.some((el) => el.review_kind === 'declined');

      return (
        <>
          {trxList.map((el, i) => {

            const {
              id,
              review_kind,
              old_status
            } = el;

            const onChange = onChangeCtor(i);
            const onInputChange = (name, value) => {
              onChange({...el, [name]: value});
            }
            const errorGetter = errorGetterCtor(i);
            const errorReviewKind = errorGetter('review_kind');

            return (
              <div key={i}>
                <div className="layoutRow">
                  <AdminFormRow className="fx1 mh-15-i">
                    <AdminFormCol className="wmax1/3-i wmax-i@m2 ph15-i">
                      <Field label="Nuvei Trx ID" className="pt10">
                        <DisplayIdAdmin>
                          {id}
                        </DisplayIdAdmin>
                      </Field>
                    </AdminFormCol>
                    <AdminFormCol className="wmax1/3-i wmax-i@m2 ph15-i">
                      <Field label="Old Status" className="pt10">
                        {old_status}
                      </Field>
                    </AdminFormCol>
                    <AdminFormCol className="wmax1/3-i wmax-i@m2 ph15-i">
                      <AdminSelect
                        label="New Status"
                        name="review_kind"

                        propName="name"
                        propValue="id"

                        items={STATUSES}

                        value={review_kind}
                        showError={click && errorReviewKind}
                        error={errorReviewKind}
                        onChange={onInputChange}
                      />
                    </AdminFormCol>
                  </AdminFormRow>
                  {moteThanOneTrx && (
                    <div className="mt37.5 ml30 pb20">
                      <Button
                        onClick={() => {
                          const nextTrxList = trxList.filter((el, index) => index !== i);
                          formCtx.onManualChange({trxList: nextTrxList})
                        }}
                      >
                        <DeleteIcon/>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
          {hasDeclinedTrx && (
            <>
              <div className="f18 fw7 lh fx1 wmin0">
                Fees for all declined transactions
              </div>

              <AdminFormRow className="mt20">
                <AdminFormCol>
                  <AdminInput
                    name="chargeback_fee"
                    label="Chargeback Fee"
                    formCtx={formCtx}
                  />
                </AdminFormCol>
                <AdminFormCol>
                  <AdminInput
                    name="chargeback_fee_eur"
                    label="Chargeback Fee (EUR)"
                    formCtx={formCtx}
                  />
                </AdminFormCol>
              </AdminFormRow>
            </>
          )}
          <FormFooter
            submitBtnData={{
              text: 'Complete',
              formCtx
            }}
            additionalBtnsList={[
              {
                text: 'Cancel',
                onClick: close
              }
            ]}
          />
        </>
      );
    }}</FormWrapper>
  )
}
